import VAvatar from './VAvatar'

VAvatar.install = function install (Vue) {
  Vue.component(VAvatar.name, VAvatar)
}

export default VAvatar



// WEBPACK FOOTER //
// ./src/components/VAvatar/index.js